import React from "react";

import { Button, Modal, ModalBody, ModalFooter, ModalHeading, useLevelsContext } from "@braze/beacon-core";

import { StackOrder } from "@lib/canvasStackOrder";

import type { ConfirmationModalWithNoIntentProps } from "../types";

export const ConfirmationModalWithNoIntent = ({
  cancelText,
  okText,
  tertiaryText,
  body,
  heading,
  isOpen,
  onCancel,
  onOk,
  onTertiary,
  size,
}: ConfirmationModalWithNoIntentProps): React.ReactElement => {
  const modalZIndex = useLevelsContext(2, StackOrder.OVERLAY_CONTENT_ABOVE_POPOVER);

  return (
    <Modal
      className="confirmation-modal"
      isOpen={isOpen}
      toggle={onCancel}
      size={size}
      ignoreOutsideClick
      hideCloseButton
      zIndex={modalZIndex}
    >
      {heading && <ModalHeading>{heading}</ModalHeading>}
      <ModalBody className="confirmation-modal_body">{body}</ModalBody>
      <ModalFooter className="confirmation-modal_footer">
        {onTertiary && (
          <ModalFooter aligner side="left">
            <Button className="confirmation-modal_tertiary-button" variant="tertiary" onClick={onTertiary}>
              {tertiaryText}
            </Button>
          </ModalFooter>
        )}
        <ModalFooter aligner side="right">
          <Button className="confirmation-modal_cancel-button" variant="secondary" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button className="confirmation-modal_ok-button" variant="primary" onClick={onOk}>
            {okText}
          </Button>
        </ModalFooter>
      </ModalFooter>
    </Modal>
  );
};
